export enum LOCALE {
  ENGLISH = 'en-gb',
  FRENCH = 'fr-ch',
  GERMAN = 'de-ch',
  ITALIAN = 'it-ch',
}

export type LocaleName = `${LOCALE}`;

export const asLocale = (value: string): LOCALE | undefined => Object.values(LOCALE).find(l => String(l) === value);
